export enum CITIZENSHIP {
  CITIZEN = 1, // Начинаем с 1, поскольку 0 это false
  FOREIGN_CITIZEN,
  NON_CITIZEN
}
